import PolicyPage from '../components/PolicyPage';

const PrivacyPolicyPage = () => {
  return (
    <PolicyPage 
      title="Privacy Policy"
      metaTitle="Privacy Policy - How We Protect Your Data"
      metaDescription="Learn how Golden Tree Events collects, uses, and protects your personal information. Our privacy policy covers data collection, storage, third-party sharing, and your rights under UAE and international law."
      sourceUrl="https://gtedubai.com/app/privacy-policy?awd=gte"
    />
  );
};

export default PrivacyPolicyPage;
